import httpClient from "../http/http-client";
import { IDistributionList, IPostDistributionListGenericTeam, IPostDistributionListIndividualContacts } from './distribution-list.model';

export default class DistributionListService {
  http;

  constructor() {
    this.http = httpClient
  }

  async createDistributionList(distributionList: IPostDistributionListIndividualContacts | IPostDistributionListGenericTeam): Promise<any> {
    return this.http.post('distribution-list', distributionList)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAll(): Promise<IDistributionList[]> {
    return this.http.get('distribution-list')
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllDistributionListsWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IDistributionList[] }> {
    return this.http.get(`distribution-list?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getDistributionList(distributionListId: string): Promise<IDistributionList> {
    return this.http.get(`distribution-list/${distributionListId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async editDistributionList(distributionListId: string, distributionList: Partial<IDistributionList>): Promise<IDistributionList> {
    return this.http.patch(`distribution-list/${distributionListId}`, distributionList)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async checkIfDistributionListInUse(distributionListId: string): Promise<any> {
    return this.http.get(`distribution-list/check-status/${distributionListId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }


  async deleteDistributionList(distributionListId: string,): Promise<any> {
    return this.http.post(`distribution-list/delete/${distributionListId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}